// Numeric fields that select their full value on focus are intended for
// immediate replacement. Suppress secondary-button pointer menus that cover the
// field, while preserving keyboard and touch menus for accessible paste actions.
export const suppressNumericInputContextMenu = (event) => {
  const nativeEvent = event.nativeEvent || event;

  if (nativeEvent.button === 2) {
    event.preventDefault();
  }
};
